import React, { useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import useStorage from "../hooks/useStorage";

// class progress-bar
const Progress = styled(motion.div)`
  /* width: ${(props) =>
    `${props.progress}%`}; // width warunkowo na podstawie zaimportowanego progress z useStorage */
  height: 0.5rem;
  background: var(--primary);
  margin-top: 2rem;
`;

// pobierz url i progres z useStorage custom hook
const ProgressBar = (props) => {
  const { url, progress } = useStorage(props.file);
  //   console.log(progress, url);

  useEffect(() => {
    //jezeli url = true (  zostaje zapisany w stanie useStorage po upladzie zdjecia) to wyczysc filestate z UpladForm.js zeby usunac progres bar ktory jest tam renderowany warnuknowo ( w UploadForm)
    if (url) {
      props.setFile(null);
    }
  }, [props, url]); // uruchom funkjce kiedy url ulegnie zmianie

  return (
    <Progress
      // progress={progress}
      initial={{ width: 0 }}
      animate={{ width: `${progress}%` }}
    ></Progress>
  );
};

export default ProgressBar;
